import { FormControlLabel, Typography, TextField, InputAdornment } from '@mui/material';
import { Controller } from 'react-hook-form-v7';
import { withStyles } from '@mui/styles';
import { COLORS } from '../../../utils/Application_Constants';

const styles = () => ({
    inputLabel: {
        order: 1,
    },
    formControlLabel: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginLeft: 0,
        marginBottom: 2,
    },
    textField: {
        order: 2,
        fontSize: 14,
        '& .MuiInputBase-root': {
            '&.Mui-error': {
                borderColor: `${COLORS.LT_PEPPER} !important`,
            },
        },
        '& input': {
            fontSize: 14,
            paddingLeft: 4,
        },
        '& .Mui-disabled': {
            backgroundColor: COLORS.LT_MIDNIGHT5,
        },
        '& .MuiInputAdornment-root': {
            marginRight: 0,
        },
        '& .MuiFormHelperText-root.Mui-error': {
            position: 'relative',
            width: '100%',
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& .MuiOutlinedInput-notchedOutline': {
            border: `1px solid ${COLORS.LT_MIDNIGHT10}`,
            borderRadius: '4px',
        },

        '&.Mui-error': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: COLORS.LT_PEPPER,
            },
        },
    },
    dollarAdornment: {
        padding: 0,
        fontSize: 14,
        color: COLORS.LT_MIDNIGHT75,
    },
});

function ProcessedTimesheetLineDetailEditInput({
    control,
    name,
    label,
    classes,
    disabled = false,
    inputProps,
    dollarInput,
    required,
    rules = {},
    ...props
}) {
    return (
        <FormControlLabel
            label={
                <Typography
                    className={classes.inputLabel}
                    variant="body2"
                    color={COLORS.LT_MIDNIGHT}
                    mb={1}
                    sx={{ fontWeight: 600 }}
                >
                    {label}
                    {required && <span style={{ color: 'red' }}> *</span>}
                </Typography>
            }
            className={classes.formControlLabel}
            control={
                <Controller
                    control={control}
                    name={name}
                    rules={{
                        ...(required ? { required: `${label} is required` } : {}),
                        ...rules,
                    }}
                    render={({ field, fieldState: { error } }) => (
                        <TextField
                            {...field}
                            className={classes.textField}
                            disabled={disabled}
                            autoComplete="off"
                            error={!!error}
                            helperText={error?.message}
                            slotProps={{
                                htmlInput: {
                                    ...inputProps,
                                    ...(dollarInput && { style: { paddingLeft: '2px' } }),
                                },
                                input: {
                                    startAdornment: dollarInput ? (
                                        <InputAdornment position="start">
                                            <Typography className={classes.dollarAdornment}>
                                                $
                                            </Typography>
                                        </InputAdornment>
                                    ) : null,
                                },
                            }}
                            {...props}
                        />
                    )}
                />
            }
        />
    );
}

export default withStyles(styles)(ProcessedTimesheetLineDetailEditInput);
